export default __webpack_public_path__ + "static/media/content-section_full-width.7919dac7.svg";